import { Environments } from './snowplow.enums';
export const SNOWPLOW_LOCAL_ENDPOINT = 'http://localhost:9090';
export const SNOWPLOW_QA_ENDPOINT = 'https://snowplow-collector-f4ewayaueq-ts.a.run.app';
export const SNOWPLOW_PRODUCTION_ENDPOINT = 'https://snowplow-collector-gebjphxznq-ts.a.run.app';
export const SNOWPLOW_COLLECTION_ENDPOINTS = {
    [Environments.test]: SNOWPLOW_LOCAL_ENDPOINT,
    [Environments.development]: SNOWPLOW_LOCAL_ENDPOINT,
    [Environments.staging]: SNOWPLOW_QA_ENDPOINT,
    [Environments.prod]: SNOWPLOW_PRODUCTION_ENDPOINT,
    [Environments.production]: SNOWPLOW_PRODUCTION_ENDPOINT,
};
export const DEBOUNCE_TIME = 500; // milliseconds
/**
 * Default plugin configurations for Snowplow tracking
 *
 * - buttonClickTracking: Tracks user interactions with buttons
 * - linkClickTracking: Monitors clicks on links within the application
 * - formTracking: Tracks form submissions and interactions
 * - activityTracking: Monitors user activity on the page (tab focus, mouse movement, scrolling)
 * - siteSearchTracking: Tracks users searching on the website
 */
export const DEFAULT_PLUGINS = {
    buttonClickTracking: {
        enabled: true,
        config: { context: [] },
    },
    linkClickTracking: {
        enabled: true,
        config: { context: [], trackContent: true },
    },
    formTracking: {
        enabled: true,
        config: { context: [] },
    },
    activityTracking: {
        enabled: true,
        config: { minimumVisitLength: 30, heartbeatDelay: 10 },
    },
    siteSearchTracking: {
        enabled: false,
        config: null,
    },
    vimeoTracking: {
        enabled: false,
    },
    html5MediaTracking: {
        enabled: false,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic25vd3Bsb3cuY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xpYi9zbm93cGxvdy5jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBR2hELE1BQU0sQ0FBQyxNQUFNLHVCQUF1QixHQUFHLHVCQUF1QixDQUFDO0FBQy9ELE1BQU0sQ0FBQyxNQUFNLG9CQUFvQixHQUFHLG9EQUFvRCxDQUFDO0FBQ3pGLE1BQU0sQ0FBQyxNQUFNLDRCQUE0QixHQUFHLG9EQUFvRCxDQUFDO0FBRWpHLE1BQU0sQ0FBQyxNQUFNLDZCQUE2QixHQUFpQztJQUN6RSxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsRUFBRSx1QkFBdUI7SUFDNUMsQ0FBQyxZQUFZLENBQUMsV0FBVyxDQUFDLEVBQUUsdUJBQXVCO0lBQ25ELENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxFQUFFLG9CQUFvQjtJQUM1QyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsRUFBRSw0QkFBNEI7SUFDakQsQ0FBQyxZQUFZLENBQUMsVUFBVSxDQUFDLEVBQUUsNEJBQTRCO0NBQy9DLENBQUM7QUFFWCxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsR0FBRyxDQUFDLENBQUMsZUFBZTtBQUVqRDs7Ozs7Ozs7R0FRRztBQUVILE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBa0I7SUFDNUMsbUJBQW1CLEVBQUU7UUFDbkIsT0FBTyxFQUFFLElBQUk7UUFDYixNQUFNLEVBQUUsRUFBRSxPQUFPLEVBQUUsRUFBRSxFQUFFO0tBQ3hCO0lBQ0QsaUJBQWlCLEVBQUU7UUFDakIsT0FBTyxFQUFFLElBQUk7UUFDYixNQUFNLEVBQUUsRUFBRSxPQUFPLEVBQUUsRUFBRSxFQUFFLFlBQVksRUFBRSxJQUFJLEVBQUU7S0FDNUM7SUFDRCxZQUFZLEVBQUU7UUFDWixPQUFPLEVBQUUsSUFBSTtRQUNiLE1BQU0sRUFBRSxFQUFFLE9BQU8sRUFBRSxFQUFFLEVBQUU7S0FDeEI7SUFDRCxnQkFBZ0IsRUFBRTtRQUNoQixPQUFPLEVBQUUsSUFBSTtRQUNiLE1BQU0sRUFBRSxFQUFFLGtCQUFrQixFQUFFLEVBQUUsRUFBRSxjQUFjLEVBQUUsRUFBRSxFQUFFO0tBQ3ZEO0lBQ0Qsa0JBQWtCLEVBQUU7UUFDbEIsT0FBTyxFQUFFLEtBQUs7UUFDZCxNQUFNLEVBQUUsSUFBSTtLQUNiO0lBQ0QsYUFBYSxFQUFFO1FBQ2IsT0FBTyxFQUFFLEtBQUs7S0FDZjtJQUNELGtCQUFrQixFQUFFO1FBQ2xCLE9BQU8sRUFBRSxLQUFLO0tBQ2Y7Q0FDTyxDQUFDIn0=